var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"alert-fixed",attrs:{"text":"","prominent":"","type":_vm.alertType,"icon":_vm.icon,"color":_vm.color,"border":"left"}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }